export const GET_LIST_TICKET = "GET_LIST_TICKET";
export const GET_LIST_TICKET_SUCCESS = "GET_LIST_TICKET_SUCCESS";
export const GET_LIST_TICKET_FAILURE = "GET_LIST_TICKET_FAILURE";

export const UPDATE_SEARCHTDATA_TICKET = "UPDATE_SEARCHTDATA_TICKET";
